/**
 * Author: Haider Ismail
 * Created: 18/10/19
 */

import $ from 'jquery';

export default class Offers {
  constructor(el) {
    this.el = el;
    this.mode = el.dataset.mode;
    this.lang = document.getElementsByTagName('html')[0].getAttribute('lang');
    this.rangeOptions = null;
    this.rangeFilterRendered = false;
    this.offerTypeFilterRendered = false;
    this.offerTypeOptions = null;
    this.rangeFilter = this.el.querySelector('select[id="rangeFilter"]');
    this.offerTypeFilter = this.el.querySelector('select[id="offerTypeFilter"]');
    this.resultsContainer = this.el.querySelector('.finance-offers--results');
    this.viewOfferButtonTxt = this.resultsContainer.dataset.viewOfferText;
    this.loader = this.el.querySelector('.finance-offers--loading');
    this.error = this.el.querySelector('.finance-offers--error');
    this.offerHoverTimeoutId = undefined;
    this.offerClickTimeoutId = undefined;
    this.offerCTADisabled = false;
    this.offers = null;
    this.offersEndpoint = '/api/v1/offers';
    (this.filterParams = {
      range: 'All',
      offerType: 'All',
    }),
      (this.currentWindowWidth = window.innerWidth),
      (this.resizeTimeoutID = undefined);
    this.bindListeners();
    this.getOffers();
    this.selectUI();
    this.watchOffersFiltersChange();
    this.manipulateHeading();
    this.setFinanceOfferField();
  }

  setFinanceOfferField() {
    this.el.querySelector('input[id="Finance Offer"]').value = `${offer.Heading}:${offer.OfferId}`;

    var productData = 'No range associated with offer; No model associated with offer';
    var hasProduct = offer.Product ? true : false;
    if (hasProduct) {
      productData = `${offer.Product.Range.Name};${offer.Product.Name}`;
    }

    if (this.el.querySelector('input[id="Input-Range-Models"]')) {
      this.el.querySelector('input[id="Input-Range-Models"]').value = productData;
    }
  }

  selectUI() {
    $('select.jcb-offer-range-filter').selectmenu({
      classes: {
        'ui-selectmenu-menu': 'jcb-bordered-drop-down',
        'ui-selectmenu-button': 'jcb-bordered-drop-down',
      },
      disable: false,
    });

    $('select.jcb-offer-offerType-filter').selectmenu({
      classes: {
        'ui-selectmenu-menu': 'jcb-bordered-drop-down',
        'ui-selectmenu-button': 'jcb-bordered-drop-down',
      },
      disable: false,
    });
  }

  watchOffersFiltersChange() {
    $('.finance-offers--filters select').on('selectmenuchange', (event, ui) => {
      this.filterOffers();
    });
  }

  enableRangeFilter() {
    $('select.jcb-offer-range-filter').selectmenu('refresh');
    $('select.jcb-offer-range-filter').selectmenu('enable');
  }

  enableOfferTypeFilter() {
    $('select.jcb-offer-offerType-filter').selectmenu('refresh');
    $('select.jcb-offer-offerType-filter').selectmenu('enable');
  }

  populateRangeFilter() {
    this.rangeFilter.options.length = 0;

    if (this.rangeOptions.length) {
      this.rangeFilter.options[this.rangeFilter.options.length] = new Option(
        'All product ranges',
        'All',
      );

      [...this.rangeOptions].forEach((range) => {
        this.rangeFilter.options[this.rangeFilter.options.length] = new Option(
          `${range.Key}`,
          range.Value,
        );
      });
    }

    this.rangeFilterRendered = true;
    this.enableRangeFilter();
  }

  populateOfferTypeFilter() {
    this.offerTypeFilter.options.length = 0;

    if (this.offerTypeOptions.length) {
      this.offerTypeFilter.options[this.offerTypeFilter.options.length] = new Option(
        'All offers',
        'All',
      );

      [...this.offerTypeOptions].forEach((range) => {
        this.offerTypeFilter.options[this.offerTypeFilter.options.length] = new Option(
          `${range.Key}`,
          range.Value,
        );
      });
    }

    this.offerTypeFilterRendered = true;
    this.enableOfferTypeFilter();
  }

  getFilterOptions() {
    if (this.rangeFilterRendered === false) {
      this.populateRangeFilter();
    }

    if (this.offerTypeFilterRendered === false) {
      this.populateOfferTypeFilter();
    }
  }

  filterOffers() {
    var rangeOption = document.querySelector('select[id="rangeFilter"]').options[
      document.querySelector('select[id="rangeFilter"]').selectedIndex
    ].value;
    var offerTypeOption = document.querySelector('select[id="offerTypeFilter"]').options[
      document.querySelector('select[id="offerTypeFilter"]').selectedIndex
    ].value;

    this.filterParams.range = rangeOption;
    this.filterParams.offerType = offerTypeOption;

    this.getOffers();
  }

  getOffers() {
    fetch(
      `${this.offersEndpoint}?language=${this.lang}&range=${this.filterParams.range}&offerType=${this.filterParams.offerType}`,
      { method: 'GET', credentials: 'include' },
    )
      .then((response) => response.json())
      .then((json) => {
        if (!this.error.classList.contains('hidden')) {
          this.error.classList.add('hidden');
        }

        this.offers = [];
        this.offers = json.SpecialOffers;
        this.renderOffers(this.offers);
        this.rangeOptions = json.RangeOptions;
        this.offerTypeOptions = json.OfferTypeOptions;
        this.getFilterOptions();
        return this;
      })
      .finally(() => {
        this.loader.classList.add('hidden');
        if (this.offers && this.offers.length <= 0) {
          this.error.classList.remove('hidden');
        }
      })
      .catch((err) => {
        console.error('[getOffers]--> err', err);
      });
  }

  /**
   *
   * @param {JSON} offers
   */
  renderOffers(offers) {
    let frag = document.createDocumentFragment();

    offers.forEach((offer, index) => {
      const div = document.createElement('div');
      div.className = 'finance-offers--results__item';

      const template1 = `
        <div class="finance-offers--results__item--img" style="background-image: url(${
          offer.Image
        })">
        </div> 
        <div class="finance-offers--results__item--content">
          <div>
            <h3>${offer.Heading}</h3>
            <p>${offer.Title}</p>
          </div>
          <div>
            <a class="jcb-btn--bordered jcb-btn js--view-offer" data-offer-id="${
              offer.OfferId
            }"  href="${offer.OfferDetailPageUrl}">
              ${this.viewOfferButtonTxt}
            </a> <small>${offer.Subheading}</small>
          </div>
						
          ${
            this.el.querySelector('[data-terms-pre-text]')
              ? '<small class="finance-offers--results__item--content__terms"><strong>' +
                this.el.querySelector('[data-terms-pre-text]').getAttribute('data-terms-pre-text') +
                '</strong> ' +
                offer.TermsAndConditions +
                '</small>'
              : '<small class="finance-offers--results__item--content__terms">' +
                offer.TermsAndConditions +
                '</small>'
          }
        </div>
      `;

      div.innerHTML = template1;
      div.classList.add('finance-offers--results__item--var-1');
      div.classList.add('finance-offers--results__item--half');

      frag.appendChild(div);
    });

    while (this.resultsContainer.hasChildNodes()) {
      this.resultsContainer.removeChild(this.resultsContainer.lastChild);
    }
    this.resultsContainer.appendChild(frag);
    this.bindOfferClickListener();
    this.matchOffersContentHeight();
    frag = null;
  }

  getOffersContentMaxHeight() {
    const offers = Array.from(
      document.querySelectorAll(
        '.finance-offers--results__item--var-1.finance-offers--results__item--half',
      ),
    );
    let maxHeight = 0;

    if (offers.length <= 0) {
      return 0;
    }

    [...offers].forEach((offer) => {
      let content = offer.querySelector('.finance-offers--results__item--content');

      if (content) {
        content.style.minHeight = `auto`;

        let contentHeight = content.clientHeight;

        if (contentHeight > maxHeight) {
          maxHeight = contentHeight;
        }
      }
    });

    return maxHeight;
  }

  matchOffersContentHeight() {
    if (window.innerWidth < 768) {
      return;
    }

    const maxHeight = this.getOffersContentMaxHeight();

    if (
      document.querySelectorAll(
        '.finance-offers--results__item--var-1.finance-offers--results__item--half',
      ).length
    ) {
      [
        ...document.querySelectorAll(
          '.finance-offers--results__item--var-1.finance-offers--results__item--half',
        ),
      ].forEach((offer) => {
        let content = offer.querySelector('.finance-offers--results__item--content');

        if (content) {
          content.style.minHeight = `${maxHeight}px`;
        }
      });
    }
  }

  bindListeners() {
    window.addEventListener('resize', () => {
      if (this.resizeTimeoutID) {
        window.clearTimeout(this.resizeTimeoutID);
      }
      this.resizeTimeoutID = window.setTimeout(() => {
        this.updateResultItemClasses();
        this.matchOffersContentHeight();
      }, 500);
    });

    window.addEventListener('orientationchange', () => {
      if (this.resizeTimeoutID) {
        window.clearTimeout(this.resizeTimeoutID);
      }

      this.resizeTimeoutID = window.setTimeout(() => {
        this.updateResultItemClasses();
        this.matchOffersContentHeight();
      }, 500);
    });
  }

  bindOfferClickListener() {
    [...this.el.querySelectorAll('.js--view-offer')].forEach((item) => {
      item.addEventListener('click', (e) => {
        window.dataLayer.push({
          event: 'finance_offer_view_offer_click',
          link_text: e.target.textContent,
          link_url: e.target.href,
        });
      });
    });
  }

  /**
   *
   * @param {Interger} id
   */
  getOfferById(id) {
    return this.offers.filter((offer) => offer.OfferId === parseInt(id))[0];
  }

  updateResultItemClasses() {
    //If window width is more  or equal to 768
    if (window.innerWidth >= 768) {
      if (this.currentWindowWidth <= 768) {
        // Render results to show variants
        this.resultsContainer.innerHTML = '';
        this.renderOffers(this.offers);
      }
    } else {
      // Render results without variants
      if (this.currentWindowWidth >= 768) {
        this.resultsContainer.innerHTML = '';
        this.renderOffers(this.offers);
      }
    }
    this.currentWindowWidth = window.innerWidth;
  }

  showVariants() {
    const windowW = window.innerWidth;
    return windowW >= 768;
  }

  manipulateHeading() {
    const heading = document.querySelector('.finance-offers--hero__heading h1');
    let headingStr = heading.textContent;

    if (headingStr !== '') {
      const strongEle = document.createElement('strong');
      const normalTextEle = document.createElement('span');
      let headingArr = headingStr.split(' ');
      let sanitisedHeadingArr = headingArr.filter((word) => word && word.replace(/\s/g, '').length);
      let firstPart = [];
      let secondPart = [];

      sanitisedHeadingArr.forEach((word, index) => {
        if (word && word.replace(/\s/g, '').length) {
          if (index <= 1) {
            firstPart.push(word);
            return;
          }
          secondPart.push(word);
        }
      });

      strongEle.innerHTML = firstPart.join(' ');
      normalTextEle.innerHTML = secondPart.join(' ');

      heading.innerHTML = '';
      heading.insertBefore(strongEle, heading.children[heading.children.length]);
      heading.insertBefore(normalTextEle, heading.children[heading.children.length]);
    }
  }
}
